<template>
  <GlassCard class="mb-5 py-5 px-5">
    <div class="mt-5">
      <p class="email-text">
        {{ emailWasSendText }}
      </p>

      <div style="display: block">
        <input
          v-model="codeToSend"
          class="w-100 c-input"
          :placeholder="inputCodeText"
          @keyup.enter="validateCodeService"
          @paste="blockPaste"
        />
        <vs-alert v-if="validateErrMsg" class="mb-1 mt-2" color="#ffffff">
          <b :style="ownerId == 23 ? 'color: #fcff45;' : 'color: #ff637e;'" style="font-size: 10px">
            <span :style="ownerId == 23 ? 'color: #fcff45;' : 'color: #ff637e;'">
              {{ validateErrMsg }}
            </span>
          </b>
        </vs-alert>

        <p
          class="mt-3 mr-4"
          style="font-size: 0.8rem; text-align: left"
          :style="template.secondaryTheme ? 'color: white;' : ''"
        >
          {{ mandatoryText }}
        </p>
      </div>

      <div>
        <button
          class="btn btn-block text-uppercase btn-black shadow-sm"
          type="submit"
          style="font-size: small; letter-spacing: 1px"
          :style="primaryBtnStyle"
          @click="validateCodeService"
        >
          {{ sendCodeBtnText }}
        </button>

        <button
          class="btn-block btn-dark btn shadow-sm text-uppercase"
          style="padding: 5px 0; font-size: small; letter-spacing: 1px"
          :style="secondaryBtnStyle"
          @click="goBack"
        >
          <i class="fa fa-caret-left"></i>
          {{ backToLoginText }}
        </button>

        <button
          class="btn-block btn-dark text-uppercase btn shadow-sm"
          type="submit"
          style="font-size: small; letter-spacing: 1px"
          :style="secondaryBtnStyle"
          @click="resendVerificationCodeService('email')"
          :disabled="isResendDisabled"
        >
          {{ resendCodeBtnText }}
          <span v-if="isResendDisabled">({{ resendCodeTimer }})</span>
        </button>
      </div>
    </div>

    <!-- modal -->
    <div v-if="showModal" class="modal-overlay">
      <div class="modal-content">
        <button class="close-btn" @click="closeModal" title="Fechar modal">X</button>

        <span
          >Escolha a opção de <br />
          reenvio do código:</span
        >
        <div class="button-container">
          <button
            class="btn-option"
            :style="{ background: btnColor, color: btnTextColor }"
            @click="resendVerificationCodeService('email')"
          >
            <i class="mr-1">
              <svg width="20px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <path
                  d="M64 112c-8.8 0-16 7.2-16 16l0 22.1L220.5 291.7c20.7 17 50.4 17 71.1 0L464 150.1l0-22.1c0-8.8-7.2-16-16-16L64 112zM48 212.2L48 384c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-171.8L322 328.8c-38.4 31.5-93.7 31.5-132 0L48 212.2zM0 128C0 92.7 28.7 64 64 64l384 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128z"
                />
              </svg>
            </i>
          </button>
        </div>
      </div>
    </div>
  </GlassCard>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex'
import store from '@/store/store.js'
import { loginFB } from '../services/ServFB.js'
import { loginV2 } from '../services/LoginV2.js'

const lFB = new loginFB()
const lv2 = new loginV2()

export default {
  name: 'TwoFactorsAuth',
  data: () => ({
    obj: {},
    codeToSend: '',
    method2FA: null,
    mandatoryText: '*Obrigatório',
    emailWasSendText:
      'Um código foi enviado para seu e-mail cadastrado. Por favor, nos informe o código recebido:',
    emailWasSendTextGuardian:
      'Um código foi enviado para o e-mail do responsável cadastrado. Por favor, nos informe o código recebido:',
    inputCodeText: 'Insira o código de confirmação',
    sendCodeBtnText: 'Validar',
    validateErrMsg: null,
    resendCodeBtnText: 'Reenviar código',
    resendCodeTimer: 60,
    isResendDisabled: true,
    backToLoginText: 'Voltar para login',
    showModal: false,
    clientId: null,
    userLogin: null,
  }),
  computed: {
    ...mapGetters(['primaryBtnStyle', 'secondaryBtnStyle']),
    ...mapState(['registrationObject', 'template', 'config']),
    primaryColor() {
      return store.state.template.primaryColor
    },
    btnColor() {
      return store.state.template.primaryBtn.bgColor
    },
    btnTextColor() {
      return store.state.template.primaryBtn.textColor
    },
  },
  mounted() {
    this.obj = JSON.parse(JSON.stringify(this.registrationObject))
    this.method2FA = this.obj.method2FA
    this.startResendTimer()
    this.clientId = this.$route.params.clientId
    this.userLogin = this.$route.params.userLogin
  },
  methods: {
    blockPaste() {
      return false
    },

    async validateCodeService() {
      let payload = {
        userLogin: this.userLogin.replace(/[.\-]/g, ''),
        code: this.codeToSend,
      }
      try {
        await lv2.validateMfa(payload, this.clientId).then(
          response => {
            if (response.header.codigo === 1) {
              window.location.href = response.data.actionData
            } else {
              this.validateErrMsg = response.header.msg
            }
          },
          err => {
            this.$bvToast.toast(err, {
              title: `Erro!`,
              solid: true,
            })
          },
        )
      } catch (err) {
        this.$bvToast.toast(err, {
          title: `Error!`,
          solid: true,
        })
      }
    },

    async resendVerificationCodeService(type) {
      let payload = {
        userLogin: type === 'email' ? this.userLogin : this.userLogin.replace(/[.\-]/g, ''),
        method: 'email',
      }

      try {
        await lv2.mfaCodeResend(payload, this.clientId).then(data => {
          if (data.header.codigo === 1) {
            this.$bvToast.toast('Código de verificação enviado', {
              title: `Código de verificação enviado`,
              solid: true,
              autoHideDelay: 10000,
            })
          } else {
            this.$bvToast.toast(data.header.msg, {
              title: `Error!`,
              solid: true,
            })
          }
        })
        this.startResendTimer()
      } catch (err) {
        this.$bvToast.toast(err, {
          title: `Error!`,
          solid: true,
        })
      }
    },
    startResendTimer() {
      this.isResendDisabled = true
      this.resendCodeTimer = 60
      let timer = setInterval(() => {
        if (this.resendCodeTimer > 0) {
          this.resendCodeTimer--
        } else {
          this.isResendDisabled = false
          clearInterval(timer)
        }
      }, 1000)
    },
    goBack() {
      window.history.back()
    },
  },
}
</script>
<style scoped>
.email-text {
  color: white !important;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-content {
  background: white;
  color: #000;
  padding: 40px 20px 20px;
  border-radius: 8px;
  position: relative;
  text-align: center;
  width: 286px;
}

.close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  border: none;
  background: none;
  color: rgb(0, 0, 0);
  font-size: 20px;
  cursor: pointer;
}

.button-container {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
}

.btn-option {
  width: 240px;
  margin: 5px;
  padding: 10px 15px;
  border: none;
  color: black;
  cursor: pointer;
  border-radius: 5px;
}
.btn-option:hover {
  background: #f4cd07;
}

@media screen and (min-width: 470px) {
  .modalContent {
    width: 435px;
  }
}

@media screen and (min-width: 767px) {
  .modalContent {
    width: 500px;
  }
}
</style>
